<template>
<div>
  <div class="vform-label white">{{ $t('export.nameForZip') }}</div>
  <input type="text" class="vform-text form-text-dark" v-model="zipName" />

  <div class="vform-label white mt-2">{{ $t('export.selectProjects') }}</div>
  <universal-selector
      @addItem="addProject"
      store-name="Project"
      list-name="zipProjects"
      :limit-by-organization-id="organizationId"
      :exclude-from-item-list="selectedProjects"
      include="instances"
      :after-query-filter="getProjectsWithForms"
  />
  <tag
      class="mt-2"
      @removeTag="removeProject"
    :key="tag.id"
    v-for="tag in selectedProjects"
    :tag="tag"
    :is-removable="true"
  />
  <project-version-checker
      :key="project.id"
      :project-id="project.id"
      :project-name="project.name"
      version-number="3.1.0"
      @versionIsNewer="versionIsInvalid(project)"
      v-for="project in selectedProjects" />
  <webapp-designer
      :organization-id="organizationId"
      @setDesign="setDesign"
  />
  <div class="w-100" />
  <div v-if="error" class="form-error p-2 mt-2 mb-2">
    {{ error && error.message ? error.message : error }}
  </div>
  <div v-if="started" class="form-error p-2 mt-2 mb-2">
    {{ started }}
  </div>
  <div class="form-error p-2 mt-2 mb-2" v-if="!selectedProjects.length">
    {{ $t('export.noProjectsSelected' )}}
  </div>
  <div
      v-if="canStart"
      @click="startZipExport"
      class="settings-button d-inline-block mt-2">
    {{ $t('start') }}
  </div>
</div>
</template>

<script>
import UniversalSelector from "@/components/organizations/UniversalSelector.vue";
import WebappDesigner from "@/components/exporter/WebappDesigner.vue";
import Tag from "@/components/Tag";
import ProjectVersionChecker from "@/components/ProjectVersionChecker.vue";
export default {
  name: "ZipExporter",
  components: {UniversalSelector, Tag, WebappDesigner, ProjectVersionChecker},
  props: {
    organizationId: {type: String, required: true},
  },
  data() {
    return {
      selectedProjects: [],
      designData: {},
      zipName: 'test' + Date.now() + '.zip',
      error: null,
      started: null,
      invalidProjects: []
    };
  },
  computed: {
    canStart() {
      return this.selectedProjects.length > 0 && !this.invalidProjects.length;
    }
  },
  methods: {
    versionIsInvalid(project) {
      console.log('versionIsInvalid', project);
      this.invalidProjects.push(project.id);
    },
    getProjectsWithForms(project) {
      if(!project.instances) {
        return false;
      }
      return project.instances.filter(item => {return item.type === 'form'}).length > 0;
    },
    async addProject(project) {
      this.selectedProjects.push(project);
      await this.loadvFormsForProject(project);
    },
    removeProject(project) {
      const {id} = project;
      const index = this.selectedProjects.findIndex(proj => {return proj.id === id});
      this.selectedProjects.splice(index, 1);
        this.invalidProjects = this.invalidProjects.filter(projectId => {
          return id !== projectId;
      });
    },
    async loadvFormsForProject(project) {
      this.error = '';
      const vform = project.instances.find(item => {
        return item.type === 'form'
      });
      console.log('vform', vform);
      if(vform && vform.assetId) {
        await this.$store.dispatch('clientLoadAsset', {
          id: vform.assetId,
        }).catch(err => {
          if(err.statusCode === 401) {
            this.error = 'You do not have access to the vForms attached to the project "' + project.name + '". An export will fail.';
          }
        })
      }
    },
    setDesign(designData) {
      this.designData = designData;
    },
    async startZipExport() {
      this.error = null;
      this.started = null;
      let args = {
        zipFileName: this.zipName,
        organizationId: this.organizationId,
        exportItems: this.selectedProjects.map(item => {
          return {
            targetId: item.id,
            type: 'vform',
            name: item.name,
            createdAt: item.createdAt,
            updatedAt: item.updatedAt,
          }
        })
      };
      if(this.designData.logo) {
          args.logo = this.designData.logo;
      }
      await this.$store.dispatch('clientPublishVformToZip', args)
          .then(response => {
            console.log(response.data);
            this.started = 'Your zip export has been started, you will receive an email when it is finished and the item will show up on the right on this page when you reload it after it is ready.';
          }).catch(error => {
            if(error.response && error.response.body) {
              this.error = 'Error: ' + error.response.body.message;
            } else {
              this.error = error;
            }
          })
    }
  }
}
</script>

<style scoped>
.form-text-dark {
  min-width: 300px;
}
</style>